import React from "react";

// Panel.Styles.ts
import styled from 'react-emotion';

export const ParagraphStyled = styled('code')`
   line-height: 40px;
   margin-right: 20px;
`;

export default class AppVersion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        version: global.appVersion
    }
  }

  render() {
      return (
            <ParagraphStyled>
                v{this.state.version}
            </ParagraphStyled>
      );
  }
}